<template>
<!-- <div> -->
    <div class="con_img" v-if="coverStyle">
        <el-image :fit="fit" :src="src" class="el-image1" >
            <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>
        <el-image :src="coverStyle" class="el-image2"></el-image>
    </div>

    <el-image :fit="fit" :src="src" v-else>
        <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
        </div>
    </el-image>
<!-- </div> -->

  
</template>

<script>
export default {
  props: {
    fit: {
      type: String,
      default: 'cover'
    },
    src: {
      type: String,
      default: ''
    },
    coverStyle: {
      type: String,
      default: ''
    }
  },
  methods:{
    setCoverStyle(val) {
      this.coverStyle = val
    }
  },
}
</script>

<style lang="scss" scoped>
.con_img{position: relative;width: 100%; height: 100%;}
.el-image2{
  position: absolute;
  z-index: 100;
  background: rgba(255, 255, 255,0) !important;
}
.el-image1{
    position: absolute;
    width: 100%; 
    height: 100%;
}
.el-image{
    background: $bgThemeColor;
    display: flex;
    justify-content: center;
    align-items: center;
    .image-slot{
        i{
            font-size: 20px;
        }
    };
}
</style>



// WEBPACK FOOTER //
// src/components/basics/lbImageGoodCover.vue